import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavBar          from './components/NavBar';
import StateTicker     from './components/StateTicker';
import Hero            from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CoverageSection from './components/CoverageSection';
import PlansSection    from './components/PlansSection';
import ReviewsSection  from './components/ReviewsSection';
import FAQSection      from './components/FAQSection';
import CTABanner       from './components/CTABanner';
import Footer          from './components/Footer';
import ThankYou        from './pages/ThankYou';

function HomePage() {
  return (
    <>
      <NavBar />
      <StateTicker />
      <Hero />
      <FeaturesSection />
      <CoverageSection />
      <PlansSection />
      <ReviewsSection />
      <FAQSection />
      <CTABanner />
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}
